// extracted by mini-css-extract-plugin
export default {"stack-app-layout":"appLayout_stack-app-layout__0X0pq","sidebar":"appLayout_sidebar__AkHD4","box-app-content":"appLayout_box-app-content__Ztz2V","reduce":"appLayout_reduce__SIQ8J"};